import { render, staticRenderFns } from "./conversationsDetail.vue?vue&type=template&id=28dcc654&scoped=true"
import script from "./conversationsDetail.vue?vue&type=script&lang=js"
export * from "./conversationsDetail.vue?vue&type=script&lang=js"
import style0 from "./conversationsDetail.vue?vue&type=style&index=0&id=28dcc654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcc654",
  null
  
)

export default component.exports